export default "__VITE_PUBLIC_ASSET__fa9d9d04__"